import { Navigate } from "react-router";
import config from "../../config";

//This function is to check whether an user is seller or customer
const getUserType = () => {
  const user = config.user;
  return user.type;
};

//Function to check the user cutomer or seller and perfoming action on it
const checkUserType = (allowedUser, component) => {
  const userType = getUserType();

  if (allowedUser.includes(userType)) {
    return component;
  } else {
    return <Navigate to="/" />;
  }
};

//Protecting the route from app.js file to access the become seller page if an user is seller
const UserType = ({ allowedUser, children }) => {
  return checkUserType(allowedUser, children);
};

export default UserType;
